module.exports = __webpack_public_path__ + "8797841ba761d39a6d2a3973aa0ef9d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/voucher/expiredVoucherImage.jpg
// module id = 201
// module chunks = 0